import { createSlice } from '@reduxjs/toolkit';
export const popupInitialState = {
    nodes: {},
    advanced: {}
};
const statusSlice = createSlice({
    name: 'popup',
    initialState: popupInitialState,
    reducers: {
        setActive: (state, action) => {
            state.nodes[action.payload] = {
                ...state.nodes[action.payload],
                active: true
            };
        },
        setInactive: (state, action) => {
            state.nodes[action.payload] = {
                ...state.nodes[action.payload],
                active: false
            };
        },
        field_write: (state, action) => {
            const { popupId, fieldType, fieldName, value } = action.payload;
            state.nodes[popupId] = {
                ...state.nodes[popupId],
                id: popupId,
                jaenFields: {
                    ...(state.nodes[popupId]?.jaenFields ?? {}),
                    [fieldType]: {
                        ...(state.nodes[popupId]?.jaenFields?.[fieldType] ?? {}),
                        [fieldName]: { value }
                    }
                }
            };
        },
        increaseAdvancedPageViews: (state, action) => {
            const popupId = action.payload;
            if (!state.advanced[popupId]) {
                state.advanced[popupId] = {
                    pageViews: 0
                };
            }
            state.advanced[popupId].pageViews++;
        }
    }
});
export const { setActive, setInactive, field_write, increaseAdvancedPageViews } = statusSlice.actions;
export default statusSlice.reducer;
